import { TQuiz } from "types/quiz";
import { create, useStore } from "zustand";

export type TLearnStore = {
  quizes: TQuiz[];
  setQuizes: (quizes: TQuiz[]) => void;

  isQuizModalOpen: boolean;
  setQuizModalOpen: (isOpen: boolean) => void;
}

export const learnStore = create<TLearnStore>((set) => ({
  quizes: [],
  setQuizes: (quizes) => set({ quizes }),

  isQuizModalOpen: false,
  setQuizModalOpen: (isQuizModalOpen) => set({ isQuizModalOpen }),
}));

export const useLearnStore = () => useStore(learnStore);
